export enum CollapseHeight {
  THREE_HEIGHT = 105,
  FOUR_HEIGHT = 155,
  FIVE_HEIGHT = 180,
  TEN_HEIGHT = 360,
}
